// extracted by mini-css-extract-plugin
export default {"sharebtn":"ShareModal_sharebtn__I+itV"};